import { RouterModule, RouterOutlet } from '@angular/router';
import { Component, AfterViewInit, OnDestroy } from '@angular/core';
import { LayoutService } from '../layout.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../../share/shared.module';
import { LayoutNavbarComponent } from '../layout-navbar/layout-navbar.component';
import { LayoutFooterComponent } from '../layout-footer/layout-footer.component';
import { LayoutSidenavComponent } from '../layout-sidenav/layout-sidenav.component';

@Component({
  selector: 'app-layout-2',
  templateUrl: './layout-2.component.html',
  styles: [':host { display: block; }', ':host ::ng-deep .layout-loading .sidenav-link { transition: none !important; }'],
  imports: [
    SharedModule,
    RouterOutlet,
    LayoutSidenavComponent,
    LayoutNavbarComponent,
    LayoutFooterComponent],
  providers: [NgbDropdownConfig] // add NgbDropdownConfig to the component providers
})
export class Layout2Component implements AfterViewInit, OnDestroy {
  // Prevent "blink" effect
  public initialized = false;

  constructor(private layoutService: LayoutService, config: NgbDropdownConfig) {
    config.placement = 'top-left';
    config.autoClose = 'outside';
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.initialized = true;

      this.layoutService.init();
      this.layoutService.update();
      this.layoutService.setAutoUpdate(true);
    });
  }

  ngOnDestroy() {
    setTimeout(() => {
      this.layoutService.destroy();
    });
  }

  closeSidenav() {
    setTimeout(() => {
      this.layoutService.setCollapsed(true);
    });
  }
}
